import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Bentleigh - Interceptor Branch Sewer Renewal </h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          The Bentleigh Interceptor Branch Sewer Renewal will upgrade five
          kilometres of sewer pipeline across Brighton East and Bentleigh. The
          upgraded pipeline will support reliability of the wider network.
        </p>
        <p>
          We completed investigation works in late 2025 to help plan these
          works.
        </p>
        <p>
          We're still tendering this project and forming the detailed design.
          We’ll update our webpage when the project is awarded to one of our
          Industry Partners.
        </p>
        <p>
          For more information visit{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/bentleigh-interceptor-branch-sewer-renewal/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Water Renewals (blue)`,
                action: '<a href> link',
                label: 'MORE INFO: Bentleigh Interceptor Branch Sewer Renewal',
              });
            }}
          >
            Brighton East and Bentleigh, Bentleigh Interceptor Branch Sewer
            Renewal | South East Water
          </a>{' '}
          email{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (blue)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Bentleigh Interceptor Branch Sewer Renewal',
              });
            }}
          >
            engagement@sew.com.au
          </a>{' '}
          or call <a href="tel:1800403777">1800 403 777</a> |{' '}
        </p>
      </div>
    </>
  );
};

export default Content;
